// !! Generated file, do not edit !!
/* tslint:disable */
/* eslint-disable */

export interface SynchronisationStatusCounts {
	synchronized: number;
	idle: number;
	scheduled: number;
}

export interface GetExploitationStatusCount {
	exploitationCount: SynchronisationStatusCounts;
	hasMedriaCount: SynchronisationStatusCounts;
	hasTbtCount: SynchronisationStatusCounts;
	hasDatahubCount: SynchronisationStatusCounts;
	hasLotsCount: SynchronisationStatusCounts;
}

export interface GetExploitationResponse {
	name: string;
	numeroCheptel: string;
	paysCheptel: string;
	mouvement: FlagMouvement;
	offreAbonnement: OffreAbonnement;
	identifiantPrimaire: IdentifiantPrimaire;
	featureUpdateLots: FeatureUpdateLots;
	featureSaisieSanitaire: FeatureSaisieSanitaire;
	featureSaisieReproduction: FeatureSaisieReproduction;
	featureSaisiePesee: FeatureSaisiePesee;
	featureDisplayAlertes: FeatureDisplayAlertes;
	featureDisplayEquarrissage: FeatureDisplayEquarrissage;
	featureCommandeBoucles: FeatureCommandeBoucles;
	type: ExploitationType;
	enabled: ExploitationEnabled;
	created: string;
	updated: string;
}

export interface CreateExploitationRequest {
	mouvement: FlagMouvement;
	numeroCheptel: string;
	paysCheptel: string;
	offreAbonnement: OffreAbonnement;
	featureUpdateLots: FeatureUpdateLots;
	type: ExploitationType;
	enabled: ExploitationEnabled;
}

export interface UpdateExploitationRequest {
	mouvement: FlagMouvement;
	offreAbonnement: OffreAbonnement;
	featureUpdateLots: FeatureUpdateLots;
	featureSaisieSanitaire: FeatureSaisieSanitaire;
	featureSaisieReproduction: FeatureSaisieReproduction;
	featureSaisiePesee: FeatureSaisiePesee;
	featureDisplayAlertes: FeatureDisplayAlertes;
	featureDisplayEquarrissage: FeatureDisplayEquarrissage;
	featureCommandeBoucles: FeatureCommandeBoucles;
	type: ExploitationType;
}

export interface GetExploitationsResponse {
	exploitations: GetExploitationResponse[];
}

export interface GetAnimalResponse {
	numeroNational: string;
	codePays: string;
	nom: string | null;
	dateNaissance: string | null;
	dateEntree: string | null;
}

export interface GetEdeFtpCredentialsResponse {
	username: string | null;
	password: string | null;
}

export interface PostEdeFtpCredentialsRequest {
	username: string;
	password: string;
}

export interface CheckEdeFtpCredentialsRequest {
	username: string;
	password: string;
}

export interface CheckEdeFtpCredentialsResponse {
	valid: boolean;
}

export interface ListMessagesResponse {
	messages: MessageResponse[];
}

export interface MessageResponse {
	messageId: string;
	titre: string;
	corps: string;
	dateCreation: string;
	dateModification: string;
	dateVisibilite: string | null;
	dateExpiration: string | null;
	destinataires: MessageDestinataireResponse[];
}

export interface MessageDestinataireResponse {
	email: string;
	numeroCheptel: string;
	statut: MessageStatut;
	dateLecture: string | null;
}

export interface PostMessageEditRequest {
	titre: string;
	corps: string;
	dateVisibilite: string | null;
	dateExpiration: string | null;
	destinataires: MessageDestinataireRequest[];
}

export interface PostMessageEditResponse {
	message: MessageResponse;
	failedDestinataireRequests: MessageDestinataireRequest[];
}

export interface MessageDestinataireRequest {
	email: string;
	numeroCheptel: string;
}

export interface CreateUserRequest {
	enabled: boolean;
	email: string;
	roles: UserRole[];
}

export interface UpdateUserRequest {
	enabled: boolean;
	email: string;
	roles: UserRole[] | null;
}

export interface GetUserResponse {
	id: string;
	enabled: boolean;
	email: string;
	exploitations: GetUserResponseExploitation[];
	roles: UserRole[];
	created: string;
	updated: string;
	deleted: string | null;
}

export interface GetUserResponseLite {
	id: string;
	enabled: boolean;
	email: string;
	created: string;
	updated: string;
	deleted: string | null;
}

export interface GetUsersResponse {
	users: GetUserResponse[];
}

export interface GetUsersResponseLite {
	users: GetUserResponseLite[];
}

export interface GetUserResponseExploitation {
	numeroCheptel: string;
	niveauAcces: NiveauAcces;
	userExploitationId: string;
}

export interface CreateUserExploitationRequest {
	userId: string;
	numeroCheptel: string;
	niveauAcces: NiveauAcces;
}

export interface UpdateUserExploitationRequest {
	niveauAcces: NiveauAcces;
}

export interface UpdateVersionRequest {
	platform: Platform;
	minimum: string | null;
	recommended: string | null;
}

export interface GetSupportedVersionsPlatformResponse {
	minimum: string;
	recommended: string;
}

export interface GetSupportedVersionsResponse {
	android: GetSupportedVersionsPlatformResponse;
	ios: GetSupportedVersionsPlatformResponse;
}

export enum OffreAbonnement {
	ESSENTIEL = 'ESSENTIEL',
	PERFORMANCE = 'PERFORMANCE',
}

export enum FlagIPE {
	IPE_ENABLED = 'IPE_ENABLED',
	IPE_DISABLED = 'IPE_DISABLED',
}

export enum FlagMouvement {
	MOUVEMENT_ENABLED = 'MOUVEMENT_ENABLED',
	MOUVEMENT_DISABLED = 'MOUVEMENT_DISABLED',
}

export enum FlagVAE {
	VAE_ENABLED = 'VAE_ENABLED',
	VAE_DISABLED = 'VAE_DISABLED',
}

export enum FeatureDisplayAlertes {
	ENABLED = 'ENABLED',
	DISABLED = 'DISABLED',
}

export enum FeatureDisplayTaches {
	ENABLED = 'ENABLED',
	DISABLED = 'DISABLED',
}

export enum FeatureDisplayEquarrissage {
	ENABLED = 'ENABLED',
	DISABLED = 'DISABLED',
}

export enum FeatureCommandeBoucles {
	ENABLED = 'ENABLED',
	DISABLED = 'DISABLED',
}

export enum FeatureSaisieIpe {
	ENABLED = 'ENABLED',
	DISABLED = 'DISABLED',
}

export enum FeatureSaisiePesee {
	ENABLED = 'ENABLED',
	DISABLED = 'DISABLED',
}

export enum FeatureSaisieReproduction {
	ENABLED = 'ENABLED',
	DISABLED = 'DISABLED',
}

export enum FeatureSaisieSanitaire {
	ENABLED = 'ENABLED',
	DISABLED = 'DISABLED',
}

export enum FeatureUpdateLots {
	ENABLED = 'ENABLED',
	DISABLED = 'DISABLED',
}

export enum FeatureCommandeIA {
	ENABLED = 'ENABLED',
	DISABLED = 'DISABLED',
}

export enum PoidsAgeTypeAgeReference {
	JOURS_120 = 'JOURS_120',
	JOURS_210 = 'JOURS_210',
	JOURS_360 = 'JOURS_360',
	JOURS_540 = 'JOURS_540',
	JOURS_720 = 'JOURS_720',
}

export enum FlagCPB {
	CPB_ENABLED = 'CPB_ENABLED',
	CPB_DISABLED = 'CPB_DISABLED',
}

export enum FlagTBT {
	TBT_ENABLED = 'TBT_ENABLED',
	TBT_DISABLED = 'TBT_DISABLED',
}

export enum FlagAccouplementPrevisionnel {
	ACCOUPLEMENT_PREVISIONNEL_ENABLED = 'ACCOUPLEMENT_PREVISIONNEL_ENABLED',
	ACCOUPLEMENT_PREVISIONNEL_DISABLED = 'ACCOUPLEMENT_PREVISIONNEL_DISABLED',
}

export enum FlagDatahub {
	DATAHUB_ENABLED = 'DATAHUB_ENABLED',
	DATAHUB_DISABLED = 'DATAHUB_DISABLED',
}

export enum FlagLots {
	LOTS_ENABLED = 'LOTS_ENABLED',
	LOTS_DISABLED = 'LOTS_DISABLED',
}

export enum FlagPesees {
	PESEES_ENABLED = 'PESEES_ENABLED',
	PESEES_DISABLED = 'PESEES_DISABLED',
}

export enum FlagSanitaires {
	SANITAIRES_ENABLED = 'SANITAIRES_ENABLED',
	SANITAIRES_DISABLED = 'SANITAIRES_DISABLED',
}

export enum ExploitationType {
	LIVE = 'LIVE',
	FAKE = 'FAKE',
}

export enum ExploitationEnabled {
	ENABLED = 'ENABLED',
	DISABLED = 'DISABLED',
}

export interface DernierePesee {
	date: string | null;
	poids: number | null;
	gmq: number | null;
}

export enum Filiere {
	BIOLOGIQUE = 'BIOLOGIQUE',
	CONVENTIONNELLE = 'CONVENTIONNELLE',
}

export enum IdentifiantPrimaire {
	NUMERO_TRAVAIL = 'NUMERO_TRAVAIL',
	NUMERO_NATIONAL = 'NUMERO_NATIONAL',
	NOM = 'NOM',
}

export enum Categorie {
	CHT = 'CHT',
	CL = 'CL',
	CT = 'CT',
	CB = 'CB',
	BO = 'BO',
}

export enum Genre {
	M = 'M',
	F = 'F',
}

export enum EdNotifStatus {
	EE = 'EE',
	ER = 'ER',
	IN = 'IN',
	SU = 'SU',
	TR = 'TR',
}

export enum ResultatDiagnosticGestationel {
	PLEINE = 'PLEINE',
	VIDE = 'VIDE',
	DOUTEUSE = 'DOUTEUSE',
	PSEUDO_GESTATION = 'PSEUDO_GESTATION',
	INCONNU = 'INCONNU',
}

export enum StatutReproduction {
	VIDE = 'VIDE',
	CONFIRMEE_GESTANTE = 'CONFIRMEE_GESTANTE',
	PRESUMEE_GESTANTE = 'PRESUMEE_GESTANTE',
	ARRET_REPRO = 'ARRET_REPRO',
	INCONNU = 'INCONNU',
}

export enum EtatControle {
	TARIE = 'TARIE',
	NON_CONTROLEE = 'NON_CONTROLEE',
	SORTIE = 'SORTIE',
	MESUREE_ROBOT = 'MESUREE_ROBOT',
	MESUREE_CONTROLE_DE_PERFORMANCES = 'MESUREE_CONTROLE_DE_PERFORMANCES',
	UNEXPECTED = 'UNEXPECTED',
}

export interface ProduitCT {
	numeroTravail: string | null;
	genre: Genre | null;
}

export enum DeclarationCauseEntree {
	ACHAT = 'ACHAT',
	PRET_OU_PENSION = 'PRET_OU_PENSION',
}

export enum CauseEntree {
	ACHAT = 'ACHAT',
	RENUMEROTATION_CHEPTEL = 'RENUMEROTATION_CHEPTEL',
	NAISSANCE = 'NAISSANCE',
	INCONNUE = 'INCONNUE',
}

export enum DeclarationRaisonSortie {
	VENTE_BOUCHERIE = 'VENTE_BOUCHERIE',
	VENTE_REPRODUCTEUR = 'VENTE_REPRODUCTEUR',
	AUTO_CONSOMMATION = 'AUTO_CONSOMMATION',
	INCONNUE = 'INCONNUE',
	MORT = 'MORT',
}

export enum CauseSortie {
	PRESOMPTION = 'PRESOMPTION',
	MORT = 'MORT',
	STERILITE = 'STERILITE',
	MAMMITES = 'MAMMITES',
	MAMELLE = 'MAMELLE',
	VIEILLESSE = 'VIEILLESSE',
	ACCIDENT = 'ACCIDENT',
	PROPHYLAXIE = 'PROPHYLAXIE',
	PRODUCTION_INSUFFISANTE = 'PRODUCTION_INSUFFISANTE',
	VENTE_ELEVAGE = 'VENTE_ELEVAGE',
	BOUCHERIE = 'BOUCHERIE',
	MALADIE_METABOLIQUE = 'MALADIE_METABOLIQUE',
	INCONNUE = 'INCONNUE',
	MISE_BAS_DIFFICILE = 'MISE_BAS_DIFFICILE',
}

export enum TypeMesure {
	ESTIME = 'ESTIME',
	MESURE = 'MESURE',
}

export type InformationsComplementaires =
	| InformationsComplementairesCT
	| InformationsComplementairesCL
	| InformationsComplementairesBO
	| InformationsComplementairesCHT
	| InformationsComplementairesCB;

export interface InformationsComplementairesCT {
	categorie: Categorie.CT;
	arretRepro: boolean;
	produits: ProduitCT[];
	dateMiseBasPrevue: string | null;
	dateDerniereMiseBasConnue: string | null;
}

export interface InformationsComplementairesCL {
	categorie: Categorie.CL;
	arretRepro: boolean;
	dateMiseBasPrevue: string | null;
	dateDerniereMiseBasConnue: string | null;
}

export interface InformationsComplementairesBO {
	categorie: Categorie.BO;
	dateDeNaissance: string | null;
}

export interface InformationsComplementairesCHT {
	categorie: Categorie.CHT;
	arretRepro: boolean;
	dateDeNaissance: string | null;
	dateMiseBasPrevue: string | null;
	dateDerniereMiseBasConnue: string | null;
}

export interface InformationsComplementairesCB {
	categorie: Categorie.CB;
	arretRepro: boolean;
	dateDeNaissance: string | null;
	dateMiseBasPrevue: string | null;
	dateDerniereMiseBasConnue: string | null;
}

export enum RangMiseBasEvenementType {
	FECONDANT_SAILLIE_SANS_MALE_DECLARE = 'FECONDANT_SAILLIE_SANS_MALE_DECLARE',
	FECONDANT_MONTE_LIBRE = 'FECONDANT_MONTE_LIBRE',
	FECONDANT_MONTE_DIRIGEE = 'FECONDANT_MONTE_DIRIGEE',
	FECONDANT_IA = 'FECONDANT_IA',
	NON_FECONDANT_ARRET_REPRO = 'NON_FECONDANT_ARRET_REPRO',
	NON_FECONDANT_ECHOGRAPHIE = 'NON_FECONDANT_ECHOGRAPHIE',
}

export interface Naissance {
	date: string | null;
	poids: number | null;
}

export interface Entree {
	date: string | null;
	cause: CauseEntree | null;
}

export interface Sortie {
	date: string | null;
	cause: CauseSortie | null;
}

export enum AlerteType {
	MISE_BAS = 'MISE_BAS',
	DELAI_ATTENTE_LAIT = 'DELAI_ATTENTE_LAIT',
	DELAI_ATTENTE_VIANDE = 'DELAI_ATTENTE_VIANDE',
	TRAITEMENT_EN_COURS = 'TRAITEMENT_EN_COURS',
}

export enum EvenementReproductionType {
	IA = 'IA',
	ML = 'ML',
	MD = 'MD',
}

export enum AutorisationMedicament {
	AUTORISE = 'AUTORISE',
	INTERDIT = 'INTERDIT',
	INCONNU = 'INCONNU',
}

export enum MedicamentSoumisOrdonnance {
	AVEC = 'AVEC',
	SANS = 'SANS',
	INCONNU = 'INCONNU',
}

export enum VoieAdministration {
	AURICULAIRE = 'AURICULAIRE',
	AUTRE = 'AUTRE',
	CUTANEE = 'CUTANEE',
	INCONNUE = 'INCONNUE',
	INHALEE = 'INHALEE',
	INTRACARDIAQUE = 'INTRACARDIAQUE',
	INTRADERMIQUE = 'INTRADERMIQUE',
	INTRAMAMMAIRE = 'INTRAMAMMAIRE',
	INTRAMUSCULAIRE = 'INTRAMUSCULAIRE',
	INTRANASALE = 'INTRANASALE',
	INTRAPERITONEALE = 'INTRAPERITONEALE',
	INTRAPULMONAIRE = 'INTRAPULMONAIRE',
	INTRARACHIDIENNE = 'INTRARACHIDIENNE',
	INTRARUMINALE = 'INTRARUMINALE',
	INTRATUMORALE = 'INTRATUMORALE',
	INTRAVEINEUSE = 'INTRAVEINEUSE',
	INTRA_ARTICULAIRE = 'INTRA_ARTICULAIRE',
	INTRA_UTERINE = 'INTRA_UTERINE',
	IN_OVO = 'IN_OVO',
	LOCALE_EXTERNE = 'LOCALE_EXTERNE',
	NASALE = 'NASALE',
	OCULAIRE = 'OCULAIRE',
	OCULO_NASALE = 'OCULO_NASALE',
	ORALE = 'ORALE',
	PARAVERTEBRALE = 'PARAVERTEBRALE',
	PERIDURALE = 'PERIDURALE',
	PERINEURALE = 'PERINEURALE',
	PERI_ARTICULAIRE = 'PERI_ARTICULAIRE',
	POUR_ON = 'POUR_ON',
	RECTALE = 'RECTALE',
	SOUS_CONJONCTIVALE = 'SOUS_CONJONCTIVALE',
	SOUS_CUTANEE = 'SOUS_CUTANEE',
	SUBLINGUALE = 'SUBLINGUALE',
	TRAITEMENT_DANS_LA_RUCHE = 'TRAITEMENT_DANS_LA_RUCHE',
	TRANSDERMIQUE = 'TRANSDERMIQUE',
	TRANSFIXION = 'TRANSFIXION',
	TREMPAGE_IMMERSION = 'TREMPAGE_IMMERSION',
	VAGINALE = 'VAGINALE',
}

export interface SynthesePerformance {
	laitVlKilogrammes: number | null;
	tbGrammesParKilogrammes: number | null;
	tpGrammesParKilogrammes: number | null;
	tauxCellulaireMilliersParMillilitres: number | null;
	tauxUreeMilligrammesParLitre: number | null;
}

export interface LaitProduit {
	vachesTraites: number | null;
	niveauBrutKilogrammes: number | null;
	laitStandardKilogrammes: number | null;
	laitVlKilogrammes: number | null;
	stadeLactation: number | null;
	variationProduction: number | null;
}

export interface Taux {
	tbGrammesParKilogrammes: number | null;
	tpGrammesParKilogrammes: number | null;
	tauxUreeMilligrammesParLitre: number | null;
}

export interface SituationCellulaire {
	tauxCellulaireMilliersParMillilitre: number | null;
	comptageInf300: number | null;
	comptageSup800: number | null;
	nombreMammites: number | null;
	nouvellesContaminations: number | null;
}

export interface NiveauDemarrage12Mois {
	nombreAnimaux: number | null;
	picMoyenAnnée: number | null;
	picMoyenAnneePrecedente: number | null;
	production12MoisAnnee: ResultatsProduction | null;
	production12MoisAnneePrecedente: ResultatsProduction | null;
}

export interface ResultatsProduction {
	vachesPresentes: number | null;
	pourcentagePrimipares: number | null;
	laitBrutKilogrammes: number | null;
	tbGrammesParKilogrammes: number | null;
	tpGrammesParKilogrammes: number | null;
	laitStandardKilogrammes: number | null;
}

export enum Variation {
	AUGMENTE = 'AUGMENTE',
	DIMINUE = 'DIMINUE',
	EGAL = 'EGAL',
	INCONNUE = 'INCONNUE',
}

export enum MomentJournee {
	MATIN = 'MATIN',
	SOIR = 'SOIR',
}

export enum Vigilance {
	OUI = 'OUI',
	NON = 'NON',
}

export enum StatutCellulaire {
	SAIN = 'SAIN',
	DOUTEUSE = 'DOUTEUSE',
	INCURABLE = 'INCURABLE',
	INFECTEE = 'INFECTEE',
	INCONNU = 'INCONNU',
}

export enum AnimalTypeIndex {
	MESURE_ECHELONNEE = 'MESURE_ECHELONNEE',
	MESURE = 'MESURE',
	TYPE = 'TYPE',
	INCONNU = 'INCONNU',
}

export enum TypeProductionLaitReference {
	REF_100J = 'REF_100J',
	REF_250J = 'REF_250J',
}

export enum TiersType {
	EXPLOITATION_ELEVAGE = 'EXPLOITATION_ELEVAGE',
	ETABLISSEMENT_ABATTAGE = 'ETABLISSEMENT_ABATTAGE',
	CENTRE_RASSEMBLEMENT = 'CENTRE_RASSEMBLEMENT',
	MARCHE = 'MARCHE',
	EXPLOITATION_NEGOCE = 'EXPLOITATION_NEGOCE',
	EXPLOITATION_SAISONNIERE = 'EXPLOITATION_SAISONNIERE',
	PARTICULIER = 'PARTICULIER',
}

export enum ClasseCellulaireType {
	S = 'S',
	G = 'G',
	I = 'I',
}

export interface TipTag {
	couleur: TipTagCouleur;
	nom: string;
}

export enum QualificationType {
	A = 'A',
	B = 'B',
	C = 'C',
	E = 'E',
	F = 'F',
	P = 'P',
	X = 'X',
}

export enum MessageStatut {
	LU = 'LU',
	NON_LU = 'NON_LU',
}

export enum SaisieType {
	MOUVEMENT_ENTREE = 'MOUVEMENT_ENTREE',
	MOUVEMENT_MISE_BAS = 'MOUVEMENT_MISE_BAS',
	MOUVEMENT_SORTIE = 'MOUVEMENT_SORTIE',
	PESEE_CHANTIER = 'PESEE_CHANTIER',
	REPRODUCTION_ARRET_REPRO = 'REPRODUCTION_ARRET_REPRO',
	REPRODUCTION_ECHOGRAPHIE = 'REPRODUCTION_ECHOGRAPHIE',
	REPRODUCTION_MONTE_LIBRE = 'REPRODUCTION_MONTE_LIBRE',
	REPRODUCTION_MONTE_DIRIGEE = 'REPRODUCTION_MONTE_DIRIGEE',
	SANITAIRE_EVENEMENT = 'SANITAIRE_EVENEMENT',
}

export enum SaisieDeclarationSynchronizationEnabled {
	ENABLED = 'ENABLED',
	DISABLED = 'DISABLED',
}

export enum SaisieMouvementDeclarationStatus {
	TRANSFER_PENDING = 'TRANSFER_PENDING',
	TRANSFER_SUCCESS = 'TRANSFER_SUCCESS',
	TRANSFER_FAILURE = 'TRANSFER_FAILURE',
	ACKNOWLEDGE_SUCCESS = 'ACKNOWLEDGE_SUCCESS',
	ACKNOWLEDGE_FAILURE = 'ACKNOWLEDGE_FAILURE',
	DELETE_PENDING = 'DELETE_PENDING',
	DELETE_SUCCESS = 'DELETE_SUCCESS',
	DELETE_FAILURE = 'DELETE_FAILURE',
}

export enum SaisieReproductionDeclarationStatus {
	TRANSFER_PENDING = 'TRANSFER_PENDING',
	TRANSFER_SUCCESS = 'TRANSFER_SUCCESS',
	TRANSFER_FAILURE = 'TRANSFER_FAILURE',
	DELETE_PENDING = 'DELETE_PENDING',
	DELETE_SUCCESS = 'DELETE_SUCCESS',
	DELETE_FAILURE = 'DELETE_FAILURE',
}

export enum SaisieSanitaireDeclarationStatus {
	TRANSFER_SUCCESS = 'TRANSFER_SUCCESS',
	DELETE_SUCCESS = 'DELETE_SUCCESS',
}

export enum SaisiePeseeDeclarationStatus {
	TRANSFER_PENDING = 'TRANSFER_PENDING',
	TRANSFER_SUCCESS = 'TRANSFER_SUCCESS',
	TRANSFER_FAILURE = 'TRANSFER_FAILURE',
	DELETE_PENDING = 'DELETE_PENDING',
	DELETE_SUCCESS = 'DELETE_SUCCESS',
	DELETE_FAILURE = 'DELETE_FAILURE',
}

export enum EchographieResultat {
	PLEINE = 'PLEINE',
	VIDE = 'VIDE',
	DOUTEUSE = 'DOUTEUSE',
	PSEUDO_GESTATION = 'PSEUDO_GESTATION',
}

export enum PartieCorps {
	ARRIERE_DROIT = 'ARRIERE_DROIT',
	ARRIERE_GAUCHE = 'ARRIERE_GAUCHE',
	AVANT_DROIT = 'AVANT_DROIT',
	AVANT_GAUCHE = 'AVANT_GAUCHE',
	DROIT = 'DROIT',
	GAUCHE = 'GAUCHE',
}

export enum PartieCorpsCategorie {
	PATTES = 'PATTES',
	QUARTIERS = 'QUARTIERS',
	FLANCS = 'FLANCS',
	AUCUN = 'AUCUN',
}

export enum TypeTraitement {
	CURATIF = 'CURATIF',
	PREVENTIF = 'PREVENTIF',
}

export enum SaisieOrigine {
	MOBILE = 'MOBILE',
	WEB = 'WEB',
}

export enum ChevreauDestination {
	ELEVAGE = 'ELEVAGE',
	BOUCHERIE = 'BOUCHERIE',
}

export enum TypeMiseBas {
	PARTIELLE = 'PARTIELLE',
	COMPLETE = 'COMPLETE',
}

export enum TipTagCouleur {
	BLANC = 'BLANC',
	BLEU = 'BLEU',
	GRIS = 'GRIS',
	JAUNE = 'JAUNE',
	MAUVE = 'MAUVE',
	ROSE = 'ROSE',
	ROUGE = 'ROUGE',
	VERT = 'VERT',
}

export enum TraitementSynchroType {
	TRAITEMENT_HORMONAL_STANDARD = 'TRAITEMENT_HORMONAL_STANDARD',
	TRAITEMENT_LUMINEUX_SANS_THS = 'TRAITEMENT_LUMINEUX_SANS_THS',
	TRAITEMENT_LUMINEUX_AVEC_THS = 'TRAITEMENT_LUMINEUX_AVEC_THS',
	TRAITEMENT_LUMINEUX_MELATONINE = 'TRAITEMENT_LUMINEUX_MELATONINE',
	MELATONINE = 'MELATONINE',
	AUTRE_METHODE = 'AUTRE_METHODE',
	THS_AVEC_TL = 'THS_AVEC_TL',
	EPONGE_EFFET_MALE_AVEC_TL = 'EPONGE_EFFET_MALE_AVEC_TL',
	EFFET_MALE_AVEC_TL = 'EFFET_MALE_AVEC_TL',
	CHALEUR_NATURELLE_AVEC_TL = 'CHALEUR_NATURELLE_AVEC_TL',
	AUTRE_METHODE_AVEC_TL = 'AUTRE_METHODE_AVEC_TL',
	THS_SANS_TL = 'THS_SANS_TL',
	EPONGE_EFFET_MALE_SANS_TL = 'EPONGE_EFFET_MALE_SANS_TL',
	EFFET_MALE_SANS_TL = 'EFFET_MALE_SANS_TL',
	CHALEUR_NATURELLE_SANS_TL = 'CHALEUR_NATURELLE_SANS_TL',
	AUTRE_METHODE_SANS_TL = 'AUTRE_METHODE_SANS_TL',
}

export enum Authority {
	ADMINISTRATION = 'ADMINISTRATION',
	CREATE_TRAITEMENTS_PERSONNALISES = 'CREATE_TRAITEMENTS_PERSONNALISES',
	DISPLAY_ADDITIONAL_VALUES_ON_INVENTORY = 'DISPLAY_ADDITIONAL_VALUES_ON_INVENTORY',
	DISPLAY_ALERTES = 'DISPLAY_ALERTES',
	DISPLAY_ANIMAUX_AUTRES_LISTES = 'DISPLAY_ANIMAUX_AUTRES_LISTES',
	DISPLAY_EQUARRISSAGE = 'DISPLAY_EQUARRISSAGE',
	COMMANDE_BOUCLES = 'COMMANDE_BOUCLES',
	DISPLAY_MESSAGES = 'DISPLAY_MESSAGES',
	GET_EXPLOITATION = 'GET_EXPLOITATION',
	GET_PERFORMANCES_GRAPHES = 'GET_PERFORMANCES_GRAPHES',
	GET_REFERENTIEL_SANITAIRES = 'GET_REFERENTIEL_SANITAIRES',
	GET_REFERENTIEL_TRAITEMENTS = 'GET_REFERENTIEL_TRAITEMENTS',
	GET_RESULTATS_INDIVIDUELS = 'GET_RESULTATS_INDIVIDUELS',
	LOT_READ = 'LOT_READ',
	LOT_WRITE = 'LOT_WRITE',
	MOUVEMENT_READ = 'MOUVEMENT_READ',
	MOUVEMENT_WRITE = 'MOUVEMENT_WRITE',
	NOTE_READ = 'NOTE_READ',
	NOTE_WRITE = 'NOTE_WRITE',
	NOTE_WRITE_LIMITED = 'NOTE_WRITE_LIMITED',
	PESEE_READ = 'PESEE_READ',
	PESEE_WRITE = 'PESEE_WRITE',
	REPRO_READ = 'REPRO_READ',
	REPRO_WRITE = 'REPRO_WRITE',
	SAISIE_HISTORIQUE = 'SAISIE_HISTORIQUE',
	SANITAIRE_READ = 'SANITAIRE_READ',
	SANITAIRE_WRITE = 'SANITAIRE_WRITE',
	TRIAGE_ANIMAUX = 'TRIAGE_ANIMAUX',
	UPDATE_EXPLOITATION_SETTINGS = 'UPDATE_EXPLOITATION_SETTINGS',
	USE_BATON_BLUETOOTH = 'USE_BATON_BLUETOOTH',
	USERS_ACCES_READ = 'USERS_ACCES_READ',
	USERS_ACCES_WRITE = 'USERS_ACCES_WRITE',
	VALORISATION_PESEES_READ = 'VALORISATION_PESEES_READ',
	VALORISATION_PESEES_WRITE = 'VALORISATION_PESEES_WRITE',
}

export enum UserRole {
	ADMINISTRATEUR = 'ADMINISTRATEUR',
	ELEVEUR = 'ELEVEUR',
}

export enum UserEnabled {
	ENABLED = 'ENABLED',
	DISABLED = 'DISABLED',
}

export enum NiveauAcces {
	SAISIE = 'SAISIE',
	CONSULTATION = 'CONSULTATION',
}

export enum Platform {
	ANDROID = 'ANDROID',
	IOS = 'IOS',
}
